import React from "react";
import Lang from "../../helpers/Lang";

class License extends React.Component {
  addImageLicenseInformation(licenseObj) {
    if (!this.props.info.media) return;

    licenseObj.photo = this.props.info.media.pictures[
      this.props.multipleActiveSlide
    ].photographer;

    if (
      this.props.info.media.pictures[this.props.multipleActiveSlide].licenses[0]
    ) {
      licenseObj.photoLicense = this.props.info.media.pictures[
        this.props.multipleActiveSlide
      ].licenses[0].description;
    }
  }

  addArtLicenseInformation(licenseObj) {
    // Art license
    if (!!this.props.info.licenses && this.props.info.licenses.length > 0) {
      const license = this.props.info.licenses[0];

      if (license.code == "pdm") {
        licenseObj.copyrightType = "pdm";
        licenseObj.copyright = "Public domain mark (CC pdm)";
        licenseObj.url =
          "http://creativecommons.org/publicdomain/mark/1.0/deed"; // KR
        licenseObj.img = "http://licensebuttons.net/p/mark/1.0/80x15.png";
      } else {
        licenseObj.copyrightType = "c";
        licenseObj.copyright = "Copyright";
      }

      licenseObj.persons = this.props.info.licenses[0].persons;

      if (licenseObj.persons) {
        licenseObj.persons.forEach(function (item) {
          if (item.role.code === "49") {
            licenseObj.person = item.name;
          }

          if (item.role.code === "E1") {
            licenseObj.org = item.name;
          }
        });
      }
    }
  }

  render() {
    let licenseObj = {};

    this.addImageLicenseInformation(licenseObj);
    this.addArtLicenseInformation(licenseObj);

    return (
      <div>
        {/* License */}
        <div>
          {Lang.get("license")}:{" "}
          {!licenseObj.copyrightType && Lang.get("contactOwner")}
          {licenseObj.copyrightType == "c" ? Lang.get("copyright") : null}
          {licenseObj.copyrightType == "pdm" && (
            <a href={licenseObj.url} target="_blank">
              {licenseObj.copyright}{" "}
              <img src={licenseObj.img} alt={licenseObj.copyright} />
            </a>
          )}
        </div>

        {/* Person */}
        <div>
          {licenseObj.person
            ? this.props.cmsData.copyrightOwnerText + ": " + licenseObj.person
            : null}
        </div>

        <br />

        {/* Organization */}
        <div>
          {licenseObj.org ? (
            <>
              {this.props.cmsData.copyrightManagerText + ": "}
              <a href="http://www.bono.no" target="_blank">
                BONO
              </a>
            </>
          ) : null}
        </div>

        {/* Photo */}
        <div>
          {this.props.cmsData.photoText}:{" "}
          {licenseObj.photo
            ? !(licenseObj.photo == "Stortinget")
              ? licenseObj.photo + " / Stortinget"
              : "Stortinget"
            : "Stortinget"}
          <br />
          {licenseObj.photoLicense ==
            "Navngivelse-Ikkekommersiell-Ingen bearbeidelse" && (
            <>
              {Lang.get("licenseOnPhoto") + ": "}
              <a
                rel="license"
                href="http://creativecommons.org/licenses/by-nc-nd/4.0/"
                target="_blank"
              >
                <img
                  alt="Creative Commons License"
                  src="https://i.creativecommons.org/l/by-nc-nd/4.0/80x15.png"
                />
              </a>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default License;
